/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.7.0 (NJsonSchema v10.6.7.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
// @ts-nocheck

import { ApiClientBase } from '@services/api-client-base';
import { TransferHttpService } from '@services/transfer-http.service';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class CategoriesApiClient extends ApiClientBase {
    private http: TransferHttpService;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TransferHttpService) http: TransferHttpService, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7265";
    }

    getCategoryByAlias(alias: string[]): Observable<CategoryResponseDto[]> {
        let url_ = this.baseUrl + "/categories/get";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(alias);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategoryByAlias(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategoryByAlias(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryResponseDto[]>;
        }));
    }

    protected processGetCategoryByAlias(response: HttpResponseBase): Observable<CategoryResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CategoryResponseDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LeadersApiClient extends ApiClientBase {
    private http: TransferHttpService;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TransferHttpService) http: TransferHttpService, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7265";
    }

    getLeadersList(): Observable<LeaderDto[]> {
        let url_ = this.baseUrl + "/leaders/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeadersList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeadersList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaderDto[]>;
        }));
    }

    protected processGetLeadersList(response: HttpResponseBase): Observable<LeaderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeaderDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PostsApiClient extends ApiClientBase {
    private http: TransferHttpService;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TransferHttpService) http: TransferHttpService, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7265";
    }

    getByPage(requestDto: PostsRequestDto): Observable<PostsListResponseDto> {
        let url_ = this.baseUrl + "/posts/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByPage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PostsListResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PostsListResponseDto>;
        }));
    }

    protected processGetByPage(response: HttpResponseBase): Observable<PostsListResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PostsListResponseDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPostView(postRequest: PostRequestDto): Observable<PostViewDto> {
        let url_ = this.baseUrl + "/posts/get-by-query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(postRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPostView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPostView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PostViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PostViewDto>;
        }));
    }

    protected processGetPostView(response: HttpResponseBase): Observable<PostViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PostViewDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProfessorsApiClient extends ApiClientBase {
    private http: TransferHttpService;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TransferHttpService) http: TransferHttpService, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7265";
    }

    getById(id: string): Observable<ProfessorDto> {
        let url_ = this.baseUrl + "/professors/get-by-id?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessorDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ProfessorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfessorDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getList(requestDto: ProfessorsRequestDto): Observable<ProfessorListResponseDto> {
        let url_ = this.baseUrl + "/professors/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessorListResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessorListResponseDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ProfessorListResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfessorListResponseDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SiteSettingsApiClient extends ApiClientBase {
    private http: TransferHttpService;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TransferHttpService) http: TransferHttpService, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7265";
    }

    getSetting(name: string | null): Observable<string> {
        let url_ = this.baseUrl + "/sitesettings/get/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetSetting(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTitleDelimiter(): Observable<string> {
        let url_ = this.baseUrl + "/sitesettings/title-delimiter";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTitleDelimiter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTitleDelimiter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetTitleDelimiter(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSiteName(): Observable<string> {
        let url_ = this.baseUrl + "/sitesettings/site-name";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSiteName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSiteName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetSiteName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExtendedMenu(): Observable<ExtendedMenuDto> {
        let url_ = this.baseUrl + "/sitesettings/extended-menu";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExtendedMenu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExtendedMenu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtendedMenuDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtendedMenuDto>;
        }));
    }

    protected processGetExtendedMenu(response: HttpResponseBase): Observable<ExtendedMenuDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExtendedMenuDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getShortMenu(): Observable<ShortMenuDto> {
        let url_ = this.baseUrl + "/sitesettings/short-menu";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShortMenu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShortMenu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShortMenuDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShortMenuDto>;
        }));
    }

    protected processGetShortMenu(response: HttpResponseBase): Observable<ShortMenuDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ShortMenuDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDefaultHomePageTitle(): Observable<string> {
        let url_ = this.baseUrl + "/sitesettings/default-home-page-title";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultHomePageTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultHomePageTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDefaultHomePageTitle(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSocialNetworkLinks(): Observable<SocialNetworkLinkDto[]> {
        let url_ = this.baseUrl + "/sitesettings/social-network-links";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSocialNetworkLinks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSocialNetworkLinks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SocialNetworkLinkDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SocialNetworkLinkDto[]>;
        }));
    }

    protected processGetSocialNetworkLinks(response: HttpResponseBase): Observable<SocialNetworkLinkDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SocialNetworkLinkDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHomePageAd(): Observable<HomePageAdDto> {
        let url_ = this.baseUrl + "/sitesettings/home-page-ad";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHomePageAd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHomePageAd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HomePageAdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HomePageAdDto>;
        }));
    }

    protected processGetHomePageAd(response: HttpResponseBase): Observable<HomePageAdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HomePageAdDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface CategoryResponseDto {
    id: string;
    name: string;
    alias: string;
    description: string;
}

export interface LeaderDto {
    link?: string;
    photoPath?: string | undefined;
    position?: string;
    name?: string;
    middleName?: string;
    surname?: string;
}

export interface PostsListResponseDto {
    items?: PostListItemDto[];
    totalCount?: number;
}

export interface PostListItemDto {
    id: string;
    title: string;
    url: string;
    previewImageId?: string | undefined;
    previewImageId2X?: string | undefined;
    eventData?: EventDataDto | undefined;
    content: string;
    postTypeName: string;
    publishedAt: Date;
}

export interface EventDataDto {
    location?: string | undefined;
    dateAndTime?: Date | undefined;
}

export interface PostsRequestDto {
    pageNumber: number;
    perPage: number;
    postType?: string | undefined;
    categoryId?: string | undefined;
    removedState: RemovedStateRequest;
    publishState: PublishStateRequest;
    frontPageState: FrontPageStateRequest;
    excludedCategories?: string[] | undefined;
    sortByPublish?: boolean;
}

export enum RemovedStateRequest {
    Excluded = "Excluded",
    Included = "Included",
    OnlyRemoved = "OnlyRemoved",
}

export enum PublishStateRequest {
    AllPublishStates = "AllPublishStates",
    Published = "Published",
    Unpubished = "Unpubished",
}

export enum FrontPageStateRequest {
    AllVisibilityStates = "AllVisibilityStates",
    Visible = "Visible",
    Invisible = "Invisible",
}

export interface PostViewDto {
    title: string;
    content: string;
    seoTitle: string;
    seoDescription: string;
    previewImageId?: string | undefined;
    previewImage2XId?: string | undefined;
    eventData?: EventDataDto | undefined;
}

export interface PostRequestDto {
    url: string;
    postType: AvailablePostType;
    getUnpublished?: boolean | undefined;
}

export enum AvailablePostType {
    News = "News",
    StaticPage = "StaticPage",
    Event = "Event",
}

export interface ProfessorDto {
    id: string;
    name: string;
    surname: string;
    middleName?: string;
    photoId?: string | undefined;
    faculty: string;
    department: string;
    description: string;
    mathNetLink?: string;
    status?: string;
    scientificTitle?: string;
    graduated?: string[];
    theses?: string[];
    termPapers?: string[];
    bibliographicIndexOfWorks?: string[];
}

export interface ProfessorListResponseDto {
    items?: ProfessorDto[];
    totalCount?: number;
}

export interface ProfessorsRequestDto {
    pageNumber: number;
    perPage: number;
    search?: string | undefined;
}

export interface ExtendedMenuDto {
    menuGroups?: MenuItemDto[][];
}

export interface MenuItemDto {
    name?: string;
    href?: string;
    title?: string;
    isHeading?: boolean;
    newTab?: boolean;
}

export interface ShortMenuDto {
    items?: MenuItemDto[];
}

export interface SocialNetworkLinkDto {
    type?: SocialNetworkType;
    link?: string;
}

export enum SocialNetworkType {
    VK = "VK",
    FaceBook = "FaceBook",
    Twitter = "Twitter",
    Youtube = "Youtube",
    Instagram = "Instagram",
    GooglePlus = "GooglePlus",
    Odnoklassniki = "Odnoklassniki",
    LinkedIn = "LinkedIn",
    LiveJournal = "LiveJournal",
    Yandex = "Yandex",
    Mail = "Mail",
}

export interface HomePageAdDto {
    title?: string;
    description?: string;
    buttonText?: string;
    buttonLink?: string;
}

export class MathApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isMathApiException = true;

    static isMathApiException(obj: any): obj is MathApiException {
        return obj.isMathApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new MathApiException(message, status, response, headers, null));
}

function blobToText(blob: Blob | null | undefined): Observable<string> {
    return new Observable<string>((observer) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            blob.text().then((text) => observer.next(text));
        }
    });
}
